import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const StateHintContainer = styled.div`
  width: 244px;
  height: 204px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background-color: ${colors.bg['white-0']};
  border: 1px solid ${colors.stroke['soft-200']};
  border-radius: 12px;


  & > span {
    font-weight: 600;
    font-size: 10px;
    line-height: 180%;
    text-align: center;
    color: ${colors.text['sub-500']};
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 20px;
  }

  @media (min-width: 1024px) and (max-width: 1440px) {
    width: 200px;
  }
`;
